module.exports = ".logo_header {\n  width: 110px !important;\n  margin-left: 50px; }\n"